module.exports = __webpack_public_path__ + "static/img/1_2_1.43422e9b.jpg";